var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.label)?_c('ViewportWrapper',{style:(_vm.computedStyle)},[_c('UX1Title',{staticStyle:{"margin":"0"},attrs:{"text":_vm.label}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }